<div class="tabs-container">
  <mat-tab-group [(selectedIndex)]="selectedIndex" class="custom-tabs">
    <mat-tab *ngFor="let tab of tabs">
      <ng-template mat-tab-label>
        <span
          [class.active-tab]="selectedIndex === tabs.indexOf(tab)"
          class="tab-label"
        >
          {{ tab.label }} ({{ tab.count }})
        </span>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <mat-form-field appearance="outline" class="search-field">
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      placeholder="Search for Category, Nibedon ID etc."
      (input)="onSearchChange($event)"
    />
  </mat-form-field>
</div>
